import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface ReviewCountResponse {
  reviewCount: number;
}

export const reviewCountKeys = {
  all: ["reviewCount"] as const,
};

export function useReviewCount() {
  return useQuery({
    queryKey: reviewCountKeys.all,
    queryFn: async () => {
      const data = await api.get<ReviewCountResponse>("/notes/review-count");
      return data.reviewCount;
    },
  });
}

export default useReviewCount;
